export default "__VITE_ASSET__7505aa0c__"